export const SVG_SIZE = 44;

export const DEFAULT_STROKE_WIDTH = 5;

export const DEFAULT_SIZE = 50;
